import React from 'react';

import { ClaimItemBase } from '~/components/Claim/types';
import { MarkdownSection } from '~/core/atoms/MarkdownSection';
import CliveAvatar from '~/core/iconComponents/special/CliveAvatar';
import SidePanel from '~/core/molecules/SidePanel';

interface DocumentSidePanelProps {
  document: ClaimItemBase;
  onClose: () => void;
  className?: string;
}

export const DocumentSidePanel: React.FC<DocumentSidePanelProps> = ({ document, onClose, className }) => (
  <SidePanel
    icon={
      <div className="rounded-lg bg-blue-900/5 p-4">
        <CliveAvatar size="lg" />
      </div>
    }
    title={document.title}
    content={
      <>
        <div className="text-md mb-4 font-semibold text-gray-900">Document Summary</div>
        <MarkdownSection markdown={document.content} />
      </>
    }
    onClose={onClose}
    className={className}
  />
);

export default DocumentSidePanel;
